var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature6D23De85(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 128,
    viewBox: "0 0 149 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.052 75.7949C143.152 83.6633 138.574 91.5627 132.601 98.7449C131.548 100.014 130.453 101.258 129.311 102.48C126.571 105.416 123.587 108.203 120.385 110.777C119.02 111.876 117.614 112.934 116.166 113.95C114.07 115.426 111.895 116.814 109.643 118.094C108.408 118.8 107.147 119.471 105.865 120.111C104.874 120.606 103.872 121.081 102.855 121.535C96.986 124.161 90.6912 126.091 84.0435 127.128C83.2131 127.257 82.3776 127.371 81.5369 127.474C80.8727 127.556 80.2033 127.623 79.5286 127.685C78.9422 127.742 78.3558 127.788 77.759 127.825C76.5083 127.907 75.2525 127.964 73.9811 127.979C70.9245 128.026 67.8056 127.886 64.6348 127.536C62.8082 127.334 60.9659 127.066 59.1081 126.726C56.9285 126.323 54.806 125.854 52.7406 125.317C51.3446 124.956 49.9746 124.564 48.6357 124.146C47.0322 123.645 45.4701 123.109 43.9444 122.531C40.1457 121.091 36.591 119.425 33.2801 117.562C29.5696 115.483 26.1705 113.156 23.0828 110.648C22.0397 109.802 21.0381 108.94 20.0729 108.053C18.7496 106.846 17.4885 105.597 16.2949 104.328C3.82985 91.0055 -1.26621 74.4895 1.45307 61.1931C6.99023 34.0896 29.4139 26.1283 48.6357 28.2747C54.9513 28.9816 60.9192 30.7772 65.8284 33.3415C68.8954 34.941 71.9261 36.0709 74.9256 36.8191C76.2956 37.1648 77.6604 37.4331 79.0201 37.624C80.0164 37.7684 81.0076 37.8768 81.9936 37.9439C83.2598 38.0367 84.5261 38.078 85.7819 38.0677C86.2697 38.0625 86.7576 38.0522 87.2402 38.0367C99.0255 37.6085 110.084 33.2177 120.058 31.5872C135.886 29.0126 156.795 46.6585 146.052 75.7949Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.052 75.7949C143.152 83.6633 138.574 91.5627 132.601 98.7449C131.548 100.014 130.453 101.258 129.311 102.48C126.571 105.416 123.587 108.202 120.385 110.777C119.021 111.876 117.614 112.934 116.166 113.95C114.07 115.426 111.895 116.814 109.643 118.093C108.408 118.8 107.147 119.471 105.865 120.111C104.874 120.606 103.872 121.081 102.855 121.535C96.986 124.161 90.6912 126.091 84.0435 127.128C83.2132 127.257 82.3777 127.37 81.537 127.474C80.8727 127.556 80.2033 127.623 79.5286 127.685C78.9422 127.742 78.3558 127.788 77.759 127.825C76.5084 127.907 75.2525 127.964 73.9811 127.979C70.9245 128.026 67.8056 127.886 64.6349 127.536C62.8082 127.334 60.9659 127.066 59.1081 126.726C56.9285 126.323 54.806 125.854 52.7406 125.317C51.3446 124.956 49.9746 124.564 48.6357 124.146V28.2747C54.9513 28.9816 60.9192 30.7771 65.8284 33.3415C68.8954 34.941 71.9261 36.0709 74.9256 36.8191C76.2956 37.1648 77.6604 37.4331 79.0201 37.624C80.0165 37.7684 81.0076 37.8768 81.9936 37.9439C83.2599 38.0367 84.5261 38.078 85.782 38.0677C86.2698 38.0625 86.7576 38.0522 87.2402 38.0367C99.0255 37.6085 110.084 33.2176 120.058 31.5872C135.886 29.0125 156.795 46.6585 146.052 75.7949Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0437 105.948V127.133C83.2133 127.262 82.3778 127.376 81.5371 127.479C80.8729 127.561 80.2034 127.628 79.5288 127.69V105.942H84.0437V105.948Z",
    fill: "#4A9AE2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0383 105.948H79.5234V112.155H84.0383V105.948Z",
    fill: "#4788D6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5419 106.959H103.66L104.583 101.33H51.5419V106.959Z",
    fill: "#5AA3E7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7549 34.6417H108.626C112.871 34.6417 116.083 38.4649 115.32 42.6184L104.583 101.33H63.8772L75.0553 40.1986C75.6469 36.979 78.4648 34.6417 81.7549 34.6417Z",
    fill: "#5AA3E7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1015 34.6417H104.973C109.218 34.6417 112.43 38.4649 111.667 42.6184L100.93 101.33H60.2238L71.4019 40.1986C71.9935 36.979 74.8113 34.6417 78.1015 34.6417Z",
    fill: "#6AACEC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5474 91.5165C81.5474 91.661 81.537 91.8106 81.5318 91.9654C81.4073 94.5297 80.5718 97.6565 77.7539 100.066C77.2298 100.52 76.633 100.943 75.9583 101.335C75.3304 101.702 74.6662 102.037 73.976 102.341C69.3885 104.385 63.7112 105.128 59.6738 105.396C56.612 105.597 54.4895 105.52 54.4895 105.52L43.9445 122.547C40.1458 121.107 36.591 119.44 33.2802 117.578C38.0026 109.338 44.1106 98.6987 46.1708 95.1282C47.0167 93.6629 48.807 92.4762 51.0437 91.5217C58.1325 88.4878 69.6895 87.7654 69.6895 87.7654L72.5022 87.6313L77.7643 87.3836L81.0181 87.234C81.0181 87.234 81.0648 87.3733 81.1271 87.6313C81.179 87.8325 81.2412 88.1111 81.2983 88.4414C81.4332 89.205 81.5682 90.2833 81.5474 91.5165Z",
    fill: "#202070"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4043 91.5165C99.3524 94.6226 98.3041 98.7193 93.8204 101.33C90.2449 103.409 85.5951 104.467 81.5318 104.999C80.1877 105.174 78.9111 105.293 77.7538 105.375C76.2281 105.478 74.9256 105.515 73.9759 105.525C72.9484 105.535 72.3412 105.515 72.3412 105.515L64.6245 127.546C62.7978 127.345 60.9555 127.077 59.0977 126.736C56.9181 126.334 54.7956 125.864 52.7302 125.328C54.2819 120.637 57.0842 112.294 59.6685 105.391C61.3499 100.886 62.9379 96.996 64.0173 95.1231C64.8632 93.6577 66.6587 92.471 68.8902 91.5165C71.5057 90.3969 74.7232 89.5971 77.7486 89.0244C78.9785 88.7922 80.1721 88.6013 81.2827 88.4414C84.853 87.9306 87.536 87.7603 87.536 87.7603L89.7986 87.6571L90.3435 87.6313L98.8594 87.234C98.8594 87.234 98.8646 87.2546 98.8801 87.2959C98.9009 87.3578 98.932 87.4765 98.9684 87.6365C99.1396 88.2969 99.4354 89.7467 99.4043 91.5165Z",
    fill: "#34318B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6586 75.7951C89.6586 76.2285 89.6585 76.6619 89.6534 77.0953C89.6378 82.5645 89.5651 87.6261 89.5651 87.6261L77.7591 85.521C77.7591 85.521 77.5308 80.8722 77.4996 77.0953C77.4944 76.6464 77.4944 76.213 77.4996 75.7951C77.51 74.0563 77.5775 72.6942 77.7643 72.3794C77.7902 72.333 77.8162 72.2453 77.8421 72.1111C77.8888 71.8428 77.9407 71.394 77.9874 70.8109C78.0601 69.8873 78.1275 68.6181 78.1846 67.1321C78.2054 66.7142 78.221 66.2808 78.2365 65.8319C78.278 64.6813 78.3196 63.4378 78.3559 62.1531C78.3663 61.7248 78.3818 61.2914 78.3922 60.8528C78.4285 59.6352 78.4597 58.3968 78.4856 57.174C78.496 56.7406 78.5064 56.302 78.5168 55.8738C78.5427 54.5994 78.5687 53.3559 78.5946 52.195C78.605 51.7513 78.6102 51.3178 78.6205 50.8948C78.688 47.4584 78.7295 44.9921 78.7451 44.9354C78.7918 44.7445 81.262 41.0399 81.262 41.0399L87.1209 39.621L89.5755 42.4278C89.5755 42.4278 89.534 46.1892 89.5029 50.8999C89.5029 51.323 89.4977 51.7564 89.4977 52.2001C89.4925 53.3972 89.4873 54.6406 89.4873 55.879C89.4873 56.3124 89.4873 56.7458 89.4873 57.1792C89.4873 58.433 89.4873 59.6764 89.4925 60.858C89.4925 61.3017 89.4977 61.7351 89.5029 62.1582C89.5132 63.5204 89.5288 64.7741 89.5496 65.837C89.56 66.2498 89.5703 66.6368 89.5755 66.9876C89.5755 67.0341 89.5807 67.0857 89.5807 67.1373C89.6118 68.2053 89.6378 69.4642 89.6482 70.8161C89.6534 71.2392 89.6586 71.6726 89.6586 72.1163C89.6534 73.3082 89.6586 74.5516 89.6586 75.7951Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4925 50.8999C89.4925 51.323 89.4874 51.7564 89.4874 52.2001H78.5895C78.5999 51.7564 78.605 51.323 78.6154 50.8999H89.4925Z",
    fill: "#EFEFF4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4769 55.8789C89.4769 56.3123 89.4769 56.7457 89.4769 57.1791H78.4856C78.496 56.7457 78.5064 56.3071 78.5167 55.8789H89.4769Z",
    fill: "#EFEFF4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4873 62.1581H78.3507C78.3611 61.7298 78.3767 61.2964 78.387 60.8578H89.4821C89.4821 61.3016 89.4821 61.735 89.4873 62.1581Z",
    fill: "#EFEFF4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5705 67.1372H78.1796C78.2003 66.7193 78.2159 66.2859 78.2315 65.837H89.5393C89.5497 66.2497 89.5601 66.6367 89.5653 66.9876C89.5653 67.034 89.5705 67.0856 89.5705 67.1372Z",
    fill: "#EFEFF4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6482 72.1165H77.8318C77.8785 71.8482 77.9304 71.3993 77.9771 70.8163H89.6378C89.6378 71.2393 89.643 71.6728 89.6482 72.1165Z",
    fill: "#EFEFF4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6586 75.795C89.6586 76.2284 89.6585 76.6618 89.6534 77.0953H77.4996C77.4944 76.6464 77.4944 76.2129 77.4996 75.795H89.6586Z",
    fill: "#EFEFF4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8378 66.5233L68.091 80.0209L52.1905 80.7742L50.5973 74.9851L60.971 72.4672L63.2855 61.1985L68.1636 61.9467L71.8378 66.5233Z",
    fill: "url(#paint2_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M101.48 86.3671C101.091 87.7137 88.8022 88.2916 87.9563 87.1565C87.5723 86.6405 86.7731 80.8205 86.3632 72.8334C85.8702 63.2416 85.9376 50.5283 87.9511 40.0801L94.412 42.8714L96.4826 45.9517L100.51 50.8585C100.51 50.8585 100.338 59.6505 100.157 65.4861C100.146 65.8472 100.136 66.1929 100.12 66.5283C99.9336 72.2813 101.869 85.0204 101.48 86.3671Z",
    fill: "url(#paint3_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M101.48 86.367C101.091 87.7136 88.8021 88.2915 87.9562 87.1564C87.5722 86.6404 86.773 80.8204 86.363 72.8333C88.1845 72.1006 90.8052 70.0729 91.3138 64.4128C92.1078 55.5692 96.0362 50.812 96.0362 50.812C96.0362 50.812 97.7072 56.4411 96.0362 63.2983L100.162 65.486C100.151 65.8471 100.141 66.1928 100.125 66.5282C99.9335 72.2812 101.869 85.0203 101.48 86.367Z",
    fill: "url(#paint4_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7347 87.1565C78.7347 87.1565 67.9925 87.4248 68.1845 86.9398C68.3765 86.4599 70.3122 82.6109 71.3656 79.19C72.4191 75.7692 72.8343 62.6896 72.8343 62.6896L71.8379 66.518C71.8379 66.518 71.8275 66.518 71.8067 66.5077C71.5992 66.4561 70.4523 66.1568 69.0356 65.7853C66.3889 65.0888 62.8134 64.1136 62.72 63.933C62.5747 63.6441 63.9291 57.6796 65.185 53.5415C66.446 49.4035 68.7657 43.9188 80.9662 41.0346C78.6517 49.0269 78.7347 87.1565 78.7347 87.1565Z",
    fill: "url(#paint5_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M103.089 66.5232C103.089 66.5232 99.1188 81.9917 95.6004 82.064C92.0767 82.1362 76.3319 79.8918 73.8254 79.675C71.3189 79.4583 68.9628 78.2665 68.9628 78.2665C68.9628 78.2665 65.3354 80.8618 64.8632 80.2168C64.4013 79.5873 66.1969 77.1468 66.2955 77.0127C66.1709 77.1159 63.3945 79.5564 62.7926 78.9579C62.175 78.3439 65.6623 73.1481 67.7277 73.0759C69.7983 73.0037 74.4066 75.2017 74.4066 75.2017L91.3139 73.757L91.9262 71.172L93.5298 64.4077L103.089 66.5232Z",
    fill: "url(#paint6_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1104 39.6209C87.1104 39.6209 95.0969 39.5486 100.977 43.8053C106.856 48.062 107.282 54.2226 103.094 66.5232C100.92 66.0691 93.5245 64.9856 93.5349 64.4077C93.5401 63.8298 96.3372 50.1568 96.3372 50.1568L87.1104 39.6209Z",
    fill: "url(#paint7_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9465 73.2357C94.8998 73.535 91.3138 73.7569 91.3138 73.7569L91.9262 71.1719C93.4467 72.1058 94.9724 73.0861 94.9465 73.2357Z",
    fill: "url(#paint8_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3894 50.0847C73.3894 50.0847 73.0261 54.0576 72.8341 62.6897L71.8066 66.5129C71.599 66.4613 70.4521 66.1621 69.0354 65.7906C70.1615 63.9486 71.324 61.4204 71.4329 58.6703C71.6457 53.1908 73.3894 50.0847 73.3894 50.0847Z",
    fill: "url(#paint9_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8811 26.1233C69.6896 26.3142 66.5396 21.4074 68.1846 19.5809C69.8297 17.7544 72.1546 19.5809 72.1546 19.5809C72.1546 19.5809 70.1722 17.9453 71.7187 16.0207C73.2651 14.0962 75.8806 17.6564 80.6705 16.934C85.4604 16.2117 89.8558 18.7296 88.9477 22.7076C92.4817 22.7076 91.4179 27.5216 89.8662 30.5502C88.3198 33.5789 85.6057 38.0575 82.4141 34.6883C79.2226 31.319 75.9792 29.9724 75.9792 29.9724L72.8811 26.1233Z",
    fill: "url(#paint10_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5939 44.0943C82.0043 44.5483 80.7225 43.2016 80.1932 42.3142C79.8714 41.7724 79.8299 40.9417 79.5912 39.9511C79.4355 39.3061 79.1968 38.5889 78.7401 37.8408L85.803 32.5728C85.7355 33.4861 86.1766 35.0185 86.6748 36.4683C87.2561 38.1504 87.9151 39.7189 87.9514 40.0801C88.0293 40.7508 87.1782 43.6402 84.5939 44.0943Z",
    fill: "url(#paint11_linear)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6746 36.4683C85.1904 40.0233 82.44 40.6889 79.5858 39.9511C79.4301 39.3061 79.1914 38.5889 78.7347 37.8408L85.7976 32.5728C85.7353 33.4861 86.1764 35.0185 86.6746 36.4683Z",
    fill: "url(#paint12_linear)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4452 24.5031C81.3037 25.9116 84.7131 24.5031 84.7131 24.5031C84.7131 24.5031 85.6005 29.4305 86.2181 29.6472C86.8356 29.8639 86.4153 27.0674 87.7957 26.7217C89.1761 26.3812 90.1206 28.7804 89.1916 30.1683C88.2679 31.5563 86.9757 31.0713 86.9757 31.0713C86.9757 31.0713 84.8169 38.5579 79.2279 38.6869C73.6388 38.8107 72.2947 31.6852 72.3674 29.704C72.4452 27.7123 72.2999 25.7259 72.4452 24.5031Z",
    fill: "url(#paint13_linear)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8136 80.0207H49.6634C49.0925 80.0207 48.6359 80.4799 48.6359 81.0423C48.6359 81.6098 49.0977 82.0639 49.6634 82.0639H72.8136C73.3844 82.0639 73.8411 81.6047 73.8411 81.0423C73.8463 80.4799 73.3844 80.0207 72.8136 80.0207Z",
    fill: "#202070"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5627 56.2194H20.208C19.1441 56.2194 18.4384 57.0759 18.6304 58.1336L22.9532 82.064H58.1585L53.8357 58.1336C53.6437 57.0759 52.6266 56.2194 51.5627 56.2194Z",
    fill: "#202070"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0908 72.3844L34.645 69.686L36.6326 66.9875L40.0732 69.686L38.0908 72.3844Z",
    fill: "url(#paint14_linear)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M61.511 81.0426C61.511 81.1922 61.3917 81.3109 61.2412 81.3109C61.0907 81.3109 60.9713 81.1922 60.9713 81.0426C60.9713 80.893 61.0907 80.7743 61.2412 80.7743C61.3917 80.7743 61.511 80.893 61.511 81.0426Z",
    fill: "url(#paint15_linear)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5588 81.3109C65.7078 81.3109 65.8286 81.1908 65.8286 81.0426C65.8286 80.8944 65.7078 80.7743 65.5588 80.7743C65.4098 80.7743 65.2889 80.8944 65.2889 81.0426C65.2889 81.1908 65.4098 81.3109 65.5588 81.3109Z",
    fill: "url(#paint16_linear)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8094 81.0424C66.8094 81.1456 66.7264 81.2281 66.6226 81.2281C66.5188 81.2281 66.4358 81.1456 66.4358 81.0424C66.4358 80.9392 66.5188 80.8566 66.6226 80.8566C66.7264 80.8566 66.8094 80.9392 66.8094 81.0424Z",
    fill: "url(#paint17_linear)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7995 81.2281H62.772C62.6682 81.2281 62.5852 81.1456 62.5852 81.0424C62.5852 80.9392 62.6682 80.8566 62.772 80.8566H63.7995C63.9033 80.8566 63.9864 80.9392 63.9864 81.0424C63.9864 81.1456 63.9033 81.2281 63.7995 81.2281Z",
    fill: "url(#paint18_linear)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M112.518 85.5209H45.605C44.645 85.5209 43.8666 84.747 43.8666 83.7924C43.8666 82.8379 44.645 82.064 45.605 82.064H112.518C113.478 82.064 114.257 82.8379 114.257 83.7924C114.257 84.747 113.478 85.5209 112.518 85.5209Z",
    fill: "#89BEF5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4835 85.5209H13.5705C12.6105 85.5209 11.832 84.747 11.832 83.7924C11.832 82.8379 12.6105 82.064 13.5705 82.064H80.4783C81.4384 82.064 82.2168 82.8379 82.2168 83.7924C82.222 84.747 81.4436 85.5209 80.4835 85.5209Z",
    fill: "#A9D0FF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7591 85.5209V127.835C76.5084 127.918 75.2526 127.974 73.9812 127.99V91.5112H20.073V108.058C18.7497 106.851 17.4886 105.602 16.295 104.333V85.5209H77.7591Z",
    fill: "#89BEF5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7539 85.5209H16.295V87.626H77.7539V85.5209Z",
    fill: "#6AACEC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M109.643 85.5209V118.099C108.408 118.806 107.147 119.476 105.865 120.116V91.5112H81.5317V127.479C80.2862 127.629 79.0252 127.747 77.7538 127.835V85.5209H109.643Z",
    fill: "#6AACEC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M109.643 85.5209H77.759V87.626H109.643V85.5209Z",
    fill: "#4788D6"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0829 91.5163V110.659C22.0398 109.812 21.0382 108.951 20.073 108.063V91.5163H23.0829Z",
    fill: "#6AACEC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M105.865 91.5163V120.121C104.874 120.617 103.872 121.091 102.855 121.545V91.5163H105.865Z",
    fill: "#4788D6"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M132.601 98.7499C129.015 103.074 124.921 107.134 120.385 110.782L122.767 75.7999H131.039L132.601 98.7499Z",
    fill: "#8FC9EF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M123.074 73.7567C122.067 63.1176 125.404 51.9831 129.457 46.8286C131.922 54.2688 123.39 59.4645 125.648 75.5729",
    fill: "url(#paint19_linear)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M123.136 72.0437C124.563 61.451 121.672 50.1978 117.832 44.8834C115.071 52.2204 123.39 57.7464 120.494 73.7567",
    fill: "url(#paint20_linear)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M123.935 75.0106C124.226 64.3302 128.388 56.1831 133.032 51.5498C134.579 59.2325 125.482 63.3705 125.772 79.6336",
    fill: "url(#paint21_linear)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M123.935 79.1071C123.644 68.4267 119.482 60.2796 114.838 55.6463C113.291 63.329 122.389 67.467 122.098 83.7301",
    fill: "url(#paint22_linear)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M129.311 102.486C126.571 105.421 123.587 108.208 120.385 110.782C119.021 111.881 117.614 112.939 116.166 113.955L118.989 72.4669H127.261L129.311 102.486Z",
    fill: "#F0F8FF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6216 3.5937V12.0142C24.6216 12.4786 24.2428 12.8552 23.7757 12.8552H11.3677L8.98054 15.2287C8.73663 15.4712 8.31628 15.3009 8.31628 14.9552V3.5937C8.31628 3.12934 8.69511 2.75269 9.16216 2.75269H23.7705C24.2428 2.75269 24.6216 3.12934 24.6216 3.5937Z",
    fill: "url(#paint23_linear)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8782 8.05653C12.8782 8.43318 12.5668 8.74276 12.188 8.74276C11.8092 8.74276 11.4978 8.43834 11.4978 8.05653C11.4978 7.67472 11.804 7.3703 12.188 7.3703C12.5668 7.3703 12.8782 7.67988 12.8782 8.05653Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1594 8.05653C17.1594 8.43318 16.8481 8.74276 16.4692 8.74276C16.0904 8.74276 15.7791 8.43834 15.7791 8.05653C15.7791 7.67472 16.0852 7.3703 16.4692 7.3703C16.8481 7.3703 17.1594 7.67988 17.1594 8.05653Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4408 8.05653C21.4408 8.43318 21.1294 8.74276 20.7506 8.74276C20.3718 8.74276 20.0604 8.43834 20.0604 8.05653C20.0604 7.67472 20.3666 7.3703 20.7506 7.3703C21.1346 7.3703 21.4408 7.67988 21.4408 8.05653Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M111.786 25.6693H106.125C104.895 25.6693 103.898 24.6786 103.898 23.4558V17.8266C103.898 16.6038 104.895 15.6132 106.125 15.6132H111.786C113.016 15.6132 114.013 16.6038 114.013 17.8266V23.4558C114.013 24.6786 113.016 25.6693 111.786 25.6693Z",
    fill: "url(#paint24_linear)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M106.924 20.5507L108.341 21.9593L110.992 19.3228",
    stroke: "white",
    strokeWidth: 1.5697,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -4.5947,
    y1: 25.6283,
    x2: 115.594,
    y2: 147.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 45.0237,
    y1: 25.9677,
    x2: 157.045,
    y2: 103.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 51.1157,
    y1: 42.7443,
    x2: 68.5745,
    y2: 92.8223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE96A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 95.5576,
    y1: 42.6733,
    x2: 92.5438,
    y2: 93.9894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C84FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 67.6514,
    y1: -10.9841,
    x2: 93.7242,
    y2: 75.7053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C84FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 72.7521,
    y1: 41.3342,
    x2: 69.7382,
    y2: 92.6503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C84FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 91.1158,
    y1: 72.0285,
    x2: 153.213,
    y2: 35.3411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE96A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 96.7334,
    y1: 42.7423,
    x2: 93.7196,
    y2: 94.0585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C84FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 94.8681,
    y1: 63.1283,
    x2: 92.3797,
    y2: 78.1446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE96A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 60.8583,
    y1: 23.9152,
    x2: 71.9575,
    y2: 60.8189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C84FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 107.643,
    y1: 114.151,
    x2: 73.59,
    y2: 2.57454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061F3E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 90.2617,
    y1: 61.384,
    x2: 72.3535,
    y2: 2.05082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE96A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 90.2498,
    y1: 61.0571,
    x2: 80.96,
    y2: 30.6186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE96A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 73.2595,
    y1: 35.8992,
    x2: 112.017,
    y2: -7.24133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE96A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 34.4497,
    y1: 66.8626,
    x2: 40.5112,
    y2: 71.0435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 60.9519,
    y1: 80.7619,
    x2: 61.5546,
    y2: 81.1776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 65.2695,
    y1: 80.7619,
    x2: 65.8722,
    y2: 81.1776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 66.4223,
    y1: 80.848,
    x2: 66.8396,
    y2: 81.1358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 62.5348,
    y1: 80.848,
    x2: 62.835,
    y2: 81.6247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 132.947,
    y1: 43.4308,
    x2: 127.487,
    y2: 59.6165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56E281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00966A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 116.403,
    y1: 47.2699,
    x2: 119.563,
    y2: 58.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56E281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00966A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 128.863,
    y1: 56.1694,
    x2: 127.643,
    y2: 90.3794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56E281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00966A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 119.743,
    y1: 55.8184,
    x2: 118.523,
    y2: 90.0282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56E281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00966A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 7.72946,
    y1: 2.46141,
    x2: 22.7504,
    y2: 15.8026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 103.898,
    y1: 17.9476,
    x2: 114.318,
    y2: 18.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F98905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7628"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature6D23De85);
export default __webpack_public_path__ + "static/media/feature-6.d23de85.d23de85f7cef0c6c240b2f27cfca7f59.svg";
export { ForwardRef as ReactComponent };